// extracted by mini-css-extract-plugin
export default {"page":"Route_page__vdeXd","header":"Route_header__sIOLt","info":"Route_info__i+GO2","items":"Route_items__wOjed","noRoute":"Route_noRoute__ZY0O8"};